import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Contact from '@/views/Contact.vue'
import About from '@/views/About.vue'
import Project from '@/views/Projects.vue'
import Try from '@/views/Try.vue'




import NotFound from '@/views/NotFound.vue'

import Instajob from '@/pages/Instajob.vue'
import Crazetrip from '@/pages/Crazetrip.vue'
import Suzuki from '@/pages/Suzuki.vue'


Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:[
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/projects',
      name: 'Project',
      component: Project
    },
    {
      path: '/projects/instajob',
      name: 'Instajob',
      component: Instajob
    },
    {
      path: '/projects/crazetrip',
      name: 'Crazetrip',
      component: Crazetrip
    },
    {
      path: '/projects/suzuki',
      name: 'Suzuki',
      component: Suzuki
    },
    {
      path: '/Try',
      name: 'Try',
      component:Try
    },
    {
      path:'*',
      name:"NotFound",
      component :NotFound,
    }
  ], 
 
});

export default router
